import apiClient from "./apiClient";

const patientsApi = {
  getAll: async ({ branchId } = {}) => {
    const response = await apiClient.get("/patients", { params: { branchId } });
    return response.data;
  },
  getById: async (patientId) => {
    const response = await apiClient.get(`/patients/${patientId}`);
    return response.data;
  },
  getSummary: async ({ branchId, startDate, endDate, jobArea } = {}) => {
    const response = await apiClient.get("/patients/analytics/summary", {
      params: { branchId, startDate, endDate, jobArea },
    });
    return response.data;
  },
  getAnalyticsJobAreas: async ({ branchId, startDate, endDate } = {}) => {
    const response = await apiClient.get("/patients/analytics/job-areas", {
      params: { branchId, startDate, endDate },
    });
    return response.data;
  },
  getImcDistribution: async ({ branchId, startDate, endDate, jobArea } = {}) => {
    const response = await apiClient.get("/patients/analytics/imc", {
      params: { branchId, startDate, endDate, jobArea },
    });
    return response.data;
  },
  getBodyFatDistribution: async ({ branchId, startDate, endDate, jobArea } = {}) => {
    const response = await apiClient.get("/patients/analytics/body-fat", {
      params: { branchId, startDate, endDate, jobArea },
    });
    return response.data;
  },
  getWaistDistribution: async ({ branchId, startDate, endDate, jobArea } = {}) => {
    const response = await apiClient.get("/patients/analytics/waist", {
      params: { branchId, startDate, endDate, jobArea },
    });
    return response.data;
  },
  getVisceralFatDistribution: async ({ branchId, startDate, endDate, jobArea } = {}) => {
    const response = await apiClient.get("/patients/analytics/visceral-fat", {
      params: { branchId, startDate, endDate, jobArea },
    });
    return response.data;
  },
  getPatientImc: async (patientId, { startDate, endDate } = {}) => {
    const response = await apiClient.get(`/patients/${patientId}/imc`, {
      params: { startDate, endDate },
    });
    return response.data;
  },
  getCheckUps: async (patientId, { startDate, endDate } = {}) => {
    const response = await apiClient.get(`/patients/${patientId}/checkups`, {
      params: { startDate, endDate },
    });
    return response.data;
  },
  createCheckUp: async (patientId, data) => {
    const response = await apiClient.post(`/patients/${patientId}/checkups`, data);
    return response.data;
  },
  uploadAgenda: async ({ branchId, file }) => {
    const formData = new FormData();
    formData.append("branchId", branchId);
    formData.append("file", file);

    const response = await apiClient.post("/patients/agenda/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
  uploadWorkbook: async ({ branchId, file, commit = false, xlsxID }) => {
    const formData = new FormData();
    formData.append("branchId", branchId);
    formData.append("file", file);
    formData.append("commit", String(commit));
    if (xlsxID) formData.append("xlsxID", xlsxID);

    const response = await apiClient.post("/patients/workbook/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
  updateCheckUp: async (patientId, checkUpId, data) => {
    const response = await apiClient.patch(`/patients/${patientId}/checkups/${checkUpId}`, data);
    return response.data;
  },
  cancelCheckUp: async (patientId, checkUpId, cancellationReason, cancelationComments) => {
    const response = await apiClient.patch(`/patients/${patientId}/checkups/${checkUpId}/cancel`, {
      cancellationReason,
      cancelationComments,
    });
    return response.data;
  },
  deleteCheckUp: async (patientId, checkUpId) => {
    const response = await apiClient.delete(`/patients/${patientId}/checkups/${checkUpId}`);
    return response.data;
  },
  create: async (data) => {
    const response = await apiClient.post("/patients", data);
    return response.data;
  },
  update: async (patientId, data) => {
    const response = await apiClient.put(`/patients/${patientId}`, data);
    return response.data;
  },
  delete: async (patientId) => {
    const response = await apiClient.delete(`/patients/${patientId}`);
    return response.data;
  },
};

export default patientsApi;
